(function ($) {

    $(document).ready(function () {
        if ($('.col-three-grid').length > 0) {
            // $('.col-three-grid .col-wrap a').html("Read More");
            var noSmallCard = $(".col-three-grid .col-wrap .small-card-wrapper").length;
            if (noSmallCard <= 0) {
                $('.col-three-grid').addClass("no-small-card");
            }
        }
    });


    $(window).on('load', function () {
        $(".col-three-grid .three-col .text-wrap h3").dotdotdot({
            height: 120,
            fallbackToLetter: true,
            watch: true,
        });
        // $(".col-three-grid .small-card .small-card-content h6").dotdotdot({
        //     height: 50,
        //     fallbackToLetter: true,
        //     watch: true,
        // });


        var size_li = $(".col-three-grid .big-card-wrapper .col-wrap").length;
        var x = 3;
        if (size_li <= 12) {
            $('.col-three-grid .btn-wrapper').hide();
        }
        $('.col-three-grid .big-card-wrapper .col-wrap:lt(' + x + ')').show();
        $('.col-three-grid .btn-wrapper .link-more').click(function () {
            x = (x + 6 <= size_li) ? x + 6 : size_li;
            $('.col-three-grid .big-card-wrapper .col-wrap:lt(' + x + ')').show();
            if (x == size_li) {
                $('.col-three-grid .btn-wrapper').hide();
            }
        });
        $('.col-three-grid .big-card-wrapper .col-wrap .small-card-wrapper .small-card .small-card-content h6').dotdotdot({
            height: 62,
            fallbackToLetter: true,
            watch: true,
        });

        $('.col-three-grid .big-card-wrapper .col-wrap .small-card-wrapper .small-card .small-card-content h6').matchHeight();
    });

})(jQuery);